import { createFileRoute } from "@tanstack/react-router";
import { SwitchExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/interactive/switch")({
  component: SwitchExamples,
});
